import { serialize } from 'cerialize'

export class CrmExpertAddRequest {
  @serialize email: string;

  constructor(email: string) {
    this.email = email
  }
}